import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import staffSearch from '_c/staff-search';
import { detailData, sendEmail } from '../component/config.js';
import searchPopup from '../../compontent/search-popup';
import Pagination from '_c/pagination';
export default {
  components: {
    staffSearch: staffSearch,
    searchPopup: searchPopup,
    Pagination: Pagination
  },
  data: function data() {
    return {
      params: this.$route.params,
      query: this.$route.query,
      detailData: detailData,
      sendEmail: sendEmail,
      deleteLoa: false,
      loading: false,
      visible: false,
      allSendLoad: false,
      allDownloadLoad: false,
      mutipleSelect: [],
      mutipleLoading: false,
      sendLoading: false,
      pickerValue: '',
      page: {
        pageSizes: [20, 50, 100],
        send_fail_count: 0,
        total: 0
      },
      row: {},
      tableData: [],
      activeEmail: '',
      email: '',
      count: -1,
      visiblePreview: false,
      previewData: '',
      clearTime: null,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 118;
    },
    detail: function detail() {
      return this.detailData[this.params.state];
    },
    selectData: function selectData() {
      return this.detail.selectData;
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;
    var keys = Object.keys(this.detail.query);
    keys.forEach(function (item) {
      if (!['certificate_state', 'page', 'page_size', 'year'].includes(item)) {
        _this.detail.query[item] = null;
      }
    });
    sessionStorage.removeItem('searchResult');
    next();
  },
  created: function created() {
    this.detail.title = this.query.name ? this.query.name : this.detail.title;
    this.$route.meta.title = this.detail.title;
    // 4为50tawi，年份默认为今年
    if (this.params.state === '4') this.pickerValue = this.detail.query.year;
    this.getTableList(1, this.detail.query);
  },
  methods: {
    // 返回列表页
    handlerBack: function handlerBack() {
      this.$router.push({
        path: this.selectData.goPath
      });
    },
    // 筛选
    handleSelect: function handleSelect() {
      this.$refs.searchPopup.init();
    },
    // 筛选
    getSearchData: function getSearchData(data) {
      var _this2 = this;
      var keys = Object.keys(this.detail.query);
      keys.forEach(function (item) {
        if (!['certificate_state', 'page', 'page_size'].includes(item)) {
          _this2.detail.query[item] = data[item] ? data[item] : '';
        }
      });
      this.getTableList(1);
    },
    // 选择员工信息
    staffChange: function staffChange(val) {
      this.detail.query.staff_id = val.staff_id;
    },
    // 获取表格信息
    getTableList: function getTableList(page) {
      var _this3 = this;
      this.tableData = [];
      this.page.total = 0;
      this.page.send_fail_count = 0;
      this.page.page = page;
      var _this$detail = this.detail,
        query = _this$detail.query,
        api = _this$detail.api,
        table = _this$detail.table;
      query.page = page;
      if (this.params.state === '4') {
        query.year = this.pickerValue ? this.pickerValue : query.year;
        if (!this.pickerValue) {
          this.$message.warning(this.$t('certificate_official_12'));
          return;
        }
      }
      if (this.params.state === '5') {
        query.task_id = this.query.id;
      }
      this.loading = true;
      api.listData(query).then(function (res) {
        var _res$data = res.data,
          header = _res$data.header,
          body = _res$data.body,
          list = _res$data.list,
          page_data = _res$data.page_data;
        if (header) {
          _this3.tableColumn = header;
          table.forEach(function (item) {
            if (header[item.prop]) item.label = header[item.prop];
          });
          _this3.tableData = body;
        } else {
          _this3.tableData = list;
        }
        _this3.page.total = page_data.total;
        _this3.page.send_fail_count = page_data.send_fail_count;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.getTableList(page);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.detail.query.page_size = size;
      this.getTableList(1);
    },
    allSend: function allSend() {
      // 全部发送
      this.visible = true;
      this.row = {};
      this.activeEmail = '';
    },
    allDownload: function allDownload() {
      var _this4 = this;
      // 全部下载
      var _this$detail2 = this.detail,
        query = _this$detail2.query,
        api = _this$detail2.api;
      api.allDownload(_objectSpread(_objectSpread({}, this.detail.query), {}, {
        year: query.year
      })).then(function (res) {
        _this4.$message.success(res.message);
        _this4.$refs.table.clearSelection(false);
        _this4.mutipleSelect = [];
      }).finally(function () {
        return _this4.mutipleLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(params) {
      // 表格选中
      this.mutipleSelect = params;
    },
    // 批量下载
    batchDownload: function batchDownload() {
      var _this5 = this;
      var staffs = this.mutipleSelect.map(function (item) {
        return item.staff_id;
      });
      if (!staffs.length) {
        this.$message.warning(this.$t('221'));
        return;
      }
      var _this$detail3 = this.detail,
        query = _this$detail3.query,
        api = _this$detail3.api;
      this.mutipleLoading = true;
      api.batchDownload({
        staff_id: staffs,
        certificate_state: query.certificate_state
      }).then(function (res) {
        _this5.$message.success(res.message);
        _this5.$refs.table.clearSelection(false);
        _this5.mutipleSelect = [];
      }).finally(function () {
        return _this5.mutipleLoading = false;
      });
    },
    // 预览
    clickPreview: function clickPreview(row) {
      var _this6 = this;
      var _this$detail4 = this.detail,
        query = _this$detail4.query,
        api = _this$detail4.api;
      this.loading = true;
      api.preview({
        staff_id: row.staff_id,
        year: query.year
      }).then(function (res) {
        _this6.visiblePreview = true;
        _this6.previewData = res.data;
      }).finally(function () {
        return _this6.loading = false;
      });
    },
    // 查看
    clickView: function clickView(row) {
      var object_url = row.oss_link[0] ? row.oss_link[0].object_url : row.oss_link.object_url;
      window.open(object_url, '_blank');
    },
    // 重新发送
    sendHandle: function sendHandle() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var api, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              api = _this7.detail.api;
              _context.next = 3;
              return api.resend({
                id: _this7.query.id
              });
            case 3:
              res = _context.sent;
              _this7.sendLoading = true;
              if (res.data) _this7.startTraining(true, api);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 开始轮训
    startTraining: function startTraining(type, api) {
      if (!type) {
        // 为false 关闭定时器
        clearTimeout(this.clearTime);
        return;
      }
      var this_ = this;
      function timerFn() {
        return _timerFn.apply(this, arguments);
      }
      function _timerFn() {
        _timerFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 获取子项目状态
                api.failTotal({
                  id: this_.query.id
                }).then(function (res) {
                  if (res.data) {
                    clearTimeout(this_.clearTime);
                    this_.$message.success(res.message);
                    this_.getTableList(1);
                    this_.sendLoading = false;
                  } else this_.clearTime = setTimeout(timerFn, 5000);
                }).catch(function () {
                  this_.sendLoading = false;
                });
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _timerFn.apply(this, arguments);
      }
      timerFn();
    },
    openSend: function openSend(row) {
      this.row = row;
      this.detail.query.email = '';
      this.email = '';
      this.activeEmail = '';
      this.visible = true;
    },
    handleClose: function handleClose() {
      this.row = {};
      this.detail.query.email = '';
      this.email = '';
      this.activeEmail = '';
      this.visible = false;
    },
    // 全部发送
    selectEmail: function selectEmail(item) {
      var _this8 = this;
      this.activeEmail = item.emalType;
      if (this.row.staff_id) this.detail.query.email = this.row[item.type];else {
        this.count = -1;
        this.detail.api.countEmail(_objectSpread({
          type: this.activeEmail
        }, this.detail.query)).then(function (res) {
          _this8.count = res.data;
        }).catch(function () {
          _this8.count = 0;
        });
      }
    },
    emailFocus: function emailFocus() {
      this.activeEmail = '3';
    },
    emailBlur: function emailBlur() {
      this.detail.query.email = this.email;
    },
    handleSend: function handleSend() {
      var _this9 = this;
      var _this$detail5 = this.detail,
        query = _this$detail5.query,
        api = _this$detail5.api;
      this.mutipleLoading = true;
      if (this.row.staff_id) {
        if (!query.email) {
          this.$message.warning(this.$t('staff_8'));
          this.mutipleLoading = false;
          return;
        }
        // 50tawi 个人发送邮箱
        if (this.params.state === '4') {
          api.send({
            staff_id: this.row.staff_id,
            email: query.email,
            type: this.activeEmail,
            year: query.year
          }).then(function (res) {
            _this9.$message.success(res.message);
            _this9.handleClose();
          }).finally(function () {
            return _this9.mutipleLoading = false;
          });
        } else {
          // 证明个人发送邮箱
          api.sendApi({
            staff_id: this.row.staff_id,
            certificate_state: query.certificate_state,
            email: query.email
          }).then(function (res) {
            _this9.handleClose();
            _this9.$message.success(res.message);
          }).finally(function () {
            return _this9.mutipleLoading = false;
          });
        }
      } else {
        // 全部发送
        var data = _objectSpread({
          send_email_type: this.activeEmail
        }, query);
        api.allSend(data).then(function (res) {
          _this9.handleClose();
          _this9.$message.success(res.message);
        }).finally(function () {
          return _this9.mutipleLoading = false;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 停止轮训
    this.startTraining(false);
  }
};